module.exports = __webpack_public_path__ + "static/media/invite-success.75f29de9.png";